import { render, staticRenderFns } from "./StatisticsBafsTourobs.vue?vue&type=template&id=58e5b5d5"
import script from "./StatisticsBafsTourobs.vue?vue&type=script&lang=js"
export * from "./StatisticsBafsTourobs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports